const o = "styles-module__inlineForm___vPwcu", e = "styles-module__inlineFormTitle___rwClW", r = "styles-module__inlineFormQuestionWrapper___eFEZL", n = "styles-module__inlineFormProgressBar___4MnmJ", t = "styles-module__formFooter___VAMlL", _ = "styles-module__formFooterLeft___N2j3v", i = "styles-module__formFooterRight___6GWwW", l = "styles-module__inlineFormError___JYS-v", s = {
  inlineForm: o,
  inlineFormTitle: e,
  inlineFormQuestionWrapper: r,
  inlineFormProgressBar: n,
  formFooter: t,
  formFooterLeft: _,
  formFooterRight: i,
  inlineFormError: l
};
export {
  s as default,
  t as formFooter,
  _ as formFooterLeft,
  i as formFooterRight,
  o as inlineForm,
  l as inlineFormError,
  n as inlineFormProgressBar,
  r as inlineFormQuestionWrapper,
  e as inlineFormTitle
};
